import { Detail } from '@pages/member-details/risk-score/utilization-measures/risks/useRisks'
import create, { SetState, StateCreator, StoreApi } from 'zustand'

interface RiskFactorDetailsStore {
    data : {
        [key: string]: Detail[]
    },
    setData : (type: string, factorId: number, details: Detail[]) => void
    clearStore: () => void
}

let store: StateCreator<RiskFactorDetailsStore, [], [], RiskFactorDetailsStore> | StoreApi<RiskFactorDetailsStore> = (set: SetState<RiskFactorDetailsStore>) => ({
    data: {},
    setData: (type, factorId, details) => {
        set(
            (state) => {
                state.data[`${type}_${factorId}`] = details

                return state
            }
        )
    },
    clearStore: () => {
        set(() => ({data:  {}}))
    }
})


export const useriskFactorDetailsStore  = create(store)
